"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _guacWidgetCore = require("@wsb/guac-widget-core");

var _dataAids = _interopRequireDefault(require("../../constants/dataAids"));

var _dateTimeFormatter = require("../../constants/propTypes/dateTimeFormatter");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AvailableTimesPeriod = function AvailableTimesPeriod(_ref) {
  var period = _ref.period,
      periodAvailableTimes = _ref.periodAvailableTimes,
      onAvailableTimeClick = _ref.onAvailableTimeClick,
      onExpandClick = _ref.onExpandClick,
      i18n = _ref.i18n,
      isMoreTimesHidden = _ref.isMoreTimesHidden,
      dateTimeFormatter = _ref.dateTimeFormatter,
      isoSelectedAvailableTime = _ref.isoSelectedAvailableTime;
  var _UX2$Element = _guacWidgetCore.UX2.Element,
      Block = _UX2$Element.Block,
      Text = _UX2$Element.Text,
      MoreLink = _UX2$Element.MoreLink,
      Details = _UX2$Element.Details;
  var timeOptionBaseStyle = {
    'width': '100%',
    'height': '100%',
    'paddingVertical': 'small',
    'textAlign': 'center',
    'cursor': 'pointer',
    'whiteSpace': 'nowrap',
    'borderWidth': '1px',
    'borderStyle': 'solid',
    'borderRadius': '2px',
    '@sm': {
      paddingVertical: 'xsmall'
    }
  };
  var styles = {
    timeOfDay: {
      fontWeight: 'bold',
      textAlign: 'center'
    },
    grid: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginHorizontal: '-2px',
      marginBottom: '-4px'
    },
    cell: {
      flexBasis: '50%',
      flexGrow: '1',
      flexShrink: '1',
      maxWidth: '50%',
      marginLeft: periodAvailableTimes.length === 1 ? '25%' : '0',
      paddingHorizontal: '2px',
      paddingBottom: '4px'
    },
    timeOption: _objectSpread({}, timeOptionBaseStyle, {
      'color': 'highContrast',
      'borderColor': 'primary'
    }),
    selectedTimeOption: _objectSpread({}, timeOptionBaseStyle, {
      'backgroundColor': 'action',
      'fontColor': 'action',
      'borderColor': 'highlight'
    }),
    moreWrapper: {
      'width': '100%',
      'marginTop': 'medium',
      'textAlign': 'center',
      '@xs': {
        display: periodAvailableTimes.length > 10 && isMoreTimesHidden[period] ? 'block' : 'none'
      },
      '@sm': {
        display: 'none'
      }
    },
    moreLink: {
      display: 'inline-block',
      marginBottom: '0',
      cursor: 'pointer'
    }
  };
  var periodHeader;

  switch (period) {
    case 'morning':
      periodHeader = i18n.morningHeader;
      break;

    case 'afternoon':
      periodHeader = i18n.afternoonHeader;
      break;

    case 'evening':
      periodHeader = i18n.eveningHeader;
      break;

    default:
      return;
  }

  return /*#__PURE__*/_react["default"].createElement(Block, null, /*#__PURE__*/_react["default"].createElement(Block, {
    style: {
      marginBottom: 'xsmall'
    }
  }, /*#__PURE__*/_react["default"].createElement(Text, {
    "data-aid": _dataAids["default"].AVAILABLE_TIMES_PERIOD_HEADER,
    featured: true,
    style: styles.timeOfDay
  }, periodHeader)), /*#__PURE__*/_react["default"].createElement(Block, {
    style: styles.grid
  }, periodAvailableTimes.map(function (isoAvailableTime, index) {
    return /*#__PURE__*/_react["default"].createElement(Block, {
      key: index,
      style: _objectSpread({}, styles.cell, {
        '@xs-only': {
          display: index > 9 && isMoreTimesHidden[period] ? 'none' : 'block'
        }
      })
    }, /*#__PURE__*/_react["default"].createElement(Details, {
      "data-aid": _dataAids["default"].AVAILABLE_TIMES_PERIOD_TIME,
      onClick: function onClick() {
        return onAvailableTimeClick(isoAvailableTime);
      },
      style: isoSelectedAvailableTime === isoAvailableTime ? styles.selectedTimeOption : styles.timeOption
    }, dateTimeFormatter.formatTime(isoAvailableTime)));
  })), /*#__PURE__*/_react["default"].createElement(Block, {
    style: styles.moreWrapper
  }, /*#__PURE__*/_react["default"].createElement(MoreLink.Expand, {
    "data-aid": _dataAids["default"].AVAILABLE_TIMES_PERIOD_EXPAND_CTA,
    onClick: function onClick() {
      return onExpandClick(period);
    },
    style: styles.moreLink,
    tag: "span"
  }, i18n.expandPeriodCta)));
};

AvailableTimesPeriod.propTypes = {
  dateTimeFormatter: _dateTimeFormatter.dateTimeFormatterPropType.isRequired,
  period: _propTypes["default"].string.isRequired,
  periodAvailableTimes: _propTypes["default"].arrayOf(_propTypes["default"].string.isRequired).isRequired,
  onAvailableTimeClick: _propTypes["default"].func.isRequired,
  onExpandClick: _propTypes["default"].func.isRequired,
  i18n: _propTypes["default"].object.isRequired,
  isMoreTimesHidden: _propTypes["default"].object.isRequired,
  isoSelectedAvailableTime: _propTypes["default"].string
};
var _default = AvailableTimesPeriod;
exports["default"] = _default;